import React from 'react';
import PropTypes from 'prop-types';
import { fireDetailsPageComponentFailureFpti } from '../../../lib/helpers';
import { clientLogger } from '../../../lib/logger';

const DetailsSectionHeader = ({
  componentContent = {},
  handleClickFPTI,
  fptiImpression
}) => {
  const { title, subtitle, fptiLinkName, style } = componentContent;

  if (!title || !subtitle) {
    fireDetailsPageComponentFailureFpti({
      data: { title, subtitle },
      componentName: 'DetailsSectionHeader',
      fptiImpression
    });
    return null;
  }
  // Default color for this component is white
  let styleObject = { backgroundColor: 'white' };

  if (style) {
    try {
      styleObject = JSON.parse(style);
    } catch (error) {
      clientLogger.warn(
        `Corrupt JSON in the style object ${style}, Error : ${error}`
      );
    }
  }

  return (
    <section id="details-section-header" style={styleObject}>
      <div className="details-section-header-container">
        <div className="details-section-text">
          <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
          <p
            dangerouslySetInnerHTML={{ __html: subtitle }}
            onClick={e =>
              e.target.tagName === 'A' && fptiLinkName
                ? handleClickFPTI(fptiLinkName)
                : {}
            }
            role="presentation"
          ></p>
        </div>
      </div>
    </section>
  );
};

DetailsSectionHeader.propTypes = {
  componentContent: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  fptiImpression: PropTypes.func.isRequired,
  fptiLinkName: PropTypes.string,
  handleClickFPTI: PropTypes.func
};

export default DetailsSectionHeader;
